export default "__VITE_ASSET__DvjU0f1s__"